import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import DataCompareBubble, { IDataCompareData, IDataCompareHelper } from '@intelligence/v3/components/DataCompareBubble';

import './index.scss';

type MaxNumberType = '99999+%' | '9999+%' | '9999+' | '999+' | '99999+' | '9999' | 'none';

interface TableShowDataProps {
  text?: string;
  // 分隔符，Global View的需求中间需要有冒号作为分隔符
  separator?: string;
  value: string | number;
  type: 'up' | 'down' | '' | (string & {});
  growth: string | any;
  isDodHide?: boolean;
  /** 用于计算列的最大宽度 */
  maxNumber?: MaxNumberType; // number | string;
  umberType?: string;
  // 文本是否可以被点击
  isTextCanBeClick?: boolean;
  // 文本点击事件
  onTextClick?: (text: string) => void;
  /** 环比气泡数据，传入后 growth 区域会显示气泡 */
  dataCompareData?: IDataCompareData & IDataCompareHelper;
}

const TITLE_MAX_WIDTH = 58;

const TableShowData = (props: TableShowDataProps) => {
  // 默认值需要去掉，暂时给未开发但重构好的页面使用
  const {
    text,
    separator,
    value = '',
    type = '',
    growth = '',
    maxNumber,
    isDodHide = false,
    onTextClick,
    isTextCanBeClick,
    dataCompareData,
  } = props;

  const growthMaxWidth = useMemo(() => {
    if (maxNumber === 'none') {
      return 96;
    }
    if (maxNumber === '99999+%') {
      return 76;
    }
    if (maxNumber === '9999+%' || maxNumber === '99999+') {
      return 68;
    }
    if (maxNumber === '9999') {
      return 50;
    }
    return 68; // mingcwang
    // return 24; // v_clinglcui
    // return 24; // REMARK: 解决冲突 暂时保留24，后续看是否需要调整为68
  }, [maxNumber]);

  return (
    <>
      <div className="dbi-row">
        <Bubble content={text} dark>
          <span
            style={{ maxWidth: `calc(100% - ${isDodHide ? TITLE_MAX_WIDTH : growthMaxWidth + TITLE_MAX_WIDTH}px)` }}
            className={classnames('dbi-row-name', { hover: isTextCanBeClick })}
            onClick={() => {
              onTextClick?.(text || '');
            }}
          >
            {text}
          </span>
        </Bubble>
        {separator && <span className="dbi-row-separator">{separator}</span>}
        <span className="dbi-row-title" style={{ maxWidth: `${TITLE_MAX_WIDTH}px` }}>
          {value}
        </span>
        {!isDodHide &&
          (type === 'up' || type === 'down' ? (
            <div
              style={{ width: `${growthMaxWidth}px` }}
              className={type === 'up' ? `dbi-row-successnum` : `dbi-row-errornum`}
            >
              <DataCompareBubble {...dataCompareData}>
                <span>{growth}</span>
              </DataCompareBubble>
              <SvgIcon className="dbi-row-arrow" type={type === 'up' ? 'green-up-new' : 'red-down-new'} />
            </div>
          ) : (
            <div style={{ width: `${growthMaxWidth}px` }} className="dbi-row-nodata">
              <DataCompareBubble {...dataCompareData}>
                <span>{growth}</span>
              </DataCompareBubble>
            </div>
          ))}
      </div>
    </>
  );
};

export default TableShowData;
